

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


export function getFilteredInvoicesX(allInvoices, filter) {

    var filteredInvoices = [...allInvoices];

        
    var filteredInvoices = allInvoices.filter(getPeriodFilterFunction(filter.period)); //filter by period

    filteredInvoices = filteredInvoices.filter(getInvoiceNoFilterFunction(filter.invoiceNo));
 
    //filteredInvoices = filteredInvoices.filter(getPaymentFilterFunction(filter.paymentStatus));  //filter by payment status

    
    return filteredInvoices;
}


const getPaymentFilterFunction = (paymentStatus) => {
   
   if (paymentStatus=="Alle") 
    return (i) => true; //return all, no filtering
   else
    return (i) => i.statusMessage==paymentStatus; //created, payed, overdue 

}

const getInvoiceNoFilterFunction = (invoiceNo) => {
   
    if (!invoiceNo || invoiceNo==='')
        return (i) => true; //return all, no filtering
    else
        return (i) => i.invoiceNumber.includes(invoiceNo);
 
 }


const getPeriodFilterFunction = (period) => {

    if (period >= 2018 && period < 2099)
        return (i) => new Date(i.invoiceDate).getFullYear()==period;

    var dict = {
        "Alle": (i) => true, //return all, no filtering
        "Siste Måned": (i) => new Date(i.invoiceDate) > addMonths(new Date(), -1),
        "3 Måneder": (i) => new Date(i.invoiceDate) > addMonths(new Date(), -3),
        "6 Måneder":   (i) => new Date(i.invoiceDate) > addMonths(new Date(), -6),
        
      };

    return dict[period];
}

const isSameMonth = (dateA, dateB) => {
    return dateA.getMonth()==dateB.getMonth() && dateA.getYear()==dateB.getYear();
}

const getDateDiffInMonths = (dateA, dateB) => {
    var difference= Math.abs(dateA-dateB);
    var months = difference/(1000 * 3600 * 24 *30)

}

const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()

const addMonths = (input, months) => {
  const date = new Date(input)
  date.setDate(1)
  date.setMonth(date.getMonth() + months)
  date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)))
  return date
}

export function binarySearch(arr = [], target) {
    const helper = (low, high) => {
        if (low > high) {
           return [];
        }
        const middle = Math.floor((low + high) / 2)
        if (arr[middle].startsWith(target)) {
           return getMatches(arr, middle, target);
        } if (arr[middle] < target) {
           return helper(middle + 1, high)
        }
        return helper(low, middle - 1)
     }
     return helper(0, arr.length - 1)
}


 const getMatches = (arr, index, target) => {
    //goes up and then down the array to find the start and end indices of matches


    //find start-index
    var startIndex = index;
    while (startIndex-1>=0 && arr[startIndex-1].startsWith(target)) {
        startIndex--;
    }

     //find end-index
     var endIndex = index;
     while (endIndex+1<=arr.length-1 && arr[endIndex+1].startsWith(target)) {
         endIndex++;
     }


     if (endIndex-startIndex ===0) //only one match
        return [arr[index]];  
     else
        return arr.slice(startIndex, endIndex); //multiple matches

    

 }